import React from 'react';

import { OTSubscriber } from 'opentok-react';

class Subscriber extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         error: null,
         audio: true,
         video: true
      };
      this.setAudio = this.setAudio.bind(this)
      this.setVideo = this.setVideo.bind(this)
      this.onError = this.onError.bind(this)
      this.onSubscribe = this.onSubscribe.bind(this)
      this.getPublisherStyle = this.getPublisherStyle.bind(this)

      this.subscriberEventHandlers = {

         connected: event => {
            const { onChangeSubscriberConnection } = this.props
            onChangeSubscriberConnection(true)
            // console.log('LOG- SUBSCRIBER - Connected', event)
         },
         destroyed: event => {
            const { onChangeSubscriberConnection } = this.props
            onChangeSubscriberConnection(false)
            // console.log('LOG- SUBSCRIBER - Destroyed', event)
         },
      };
   }

   setAudio(audio) {
      this.setState({ audio });
   }

   setVideo(video) {
      this.setState({ video });
   }

   onError(err) {
      // console.log("Subscriber error")
      // this.setState({ error: `Failed to subscribe: ${err.message}` });
   }

   onSubscribe() {
      // console.log("OnSubscribe")
   }

   componentWillMount() {
      const { changeSubscriberStatus } = this.props
      changeSubscriberStatus(true)
   }
   componentWillUnmount() {
      const { changeSubscriberStatus } = this.props
      changeSubscriberStatus(false)
   }

   getPublisherStyle() {
      const { subscriberConnected } = this.props
      let borderColor = subscriberConnected ? 'rgb(29,159,173)' : 'rgb(238,141,35)'
      let subscriberStyle = {
         border: `5px solid ${borderColor}`,
         borderRadius: '10px',
         top: 0,
         left: 0,
         width: 'calc(100% - 10px)',
         height: 'calc(100% - 10px)',
         position: 'absolute',
      }
      return subscriberStyle
   }

   render() {
      const { appointment, subscriberConnected, onChangeSubscriberConnection } = this.props
      return (
         <div className="subscriber">
            {this.state.error ? <div id="error">{this.state.error}</div> : null}

            <OTSubscriber style={this.getPublisherStyle()}
               session={this.props.session}
               properties={{
                  subscribeToAudio: this.state.audio,
                  subscribeToVideo: this.state.video,
                  name: appointment.dtoProfessional.professionalGender === 'male' ? `Dr. ${appointment.dtoProfessional.fullName}` : `Dra. ${appointment.dtoProfessional.fullName}`,
                  style: {
                     buttonDisplayMode: 'off',
                     nameDisplayMode: 'on'
                  }
               }}
               retry={true}
               maxRetryAttempts={5}
               eventHandlers={this.subscriberEventHandlers}
               onError={this.onError}
               onSubscribe={this.onSubscribe} />
         </div>
      );
   }
}
export default Subscriber;



// WEBPACK FOOTER //
// ./src/containers/TeleHealthVideo/tokboxComponents/Subscriber.js